import React from "react";
import { TiTick } from "react-icons/ti";

const Stepper = ({ steps, currentStep, complete = false }) => {
  return (
    <div className="flex justify-between w-full my-2">
      {steps?.map((step, i) => (
        <div
          key={i}
          className={`step-item ${currentStep === i + 1 && "active"} ${
            (i + 1 < currentStep || complete) && "complete"
          } `}
        >
          <div className="step">
            {i + 1 < currentStep || complete ? <TiTick size={24} /> : i + 1}
          </div>
          <p className="text-gray-500 mt-2">{step.name}</p>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
